/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyRateWithCurrency
 */
export interface DailyRateWithCurrency {
    /**
     * 
     * @type {string}
     * @memberof DailyRateWithCurrency
     */
    currencyCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof DailyRateWithCurrency
     */
    hidden: boolean;
    /**
     * 
     * @type {number}
     * @memberof DailyRateWithCurrency
     */
    price: number;
}

/**
 * Check if a given object implements the DailyRateWithCurrency interface.
 */
export function instanceOfDailyRateWithCurrency(value: object): value is DailyRateWithCurrency {
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('hidden' in value) || value['hidden'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function DailyRateWithCurrencyFromJSON(json: any): DailyRateWithCurrency {
    return DailyRateWithCurrencyFromJSONTyped(json, false);
}

export function DailyRateWithCurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyRateWithCurrency {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyCode': json['currencyCode'],
        'hidden': json['hidden'],
        'price': json['price'],
    };
}

export function DailyRateWithCurrencyToJSON(value?: DailyRateWithCurrency | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currencyCode': value['currencyCode'],
        'hidden': value['hidden'],
        'price': value['price'],
    };
}

